/**
 * @generated SignedSource<<a9852c447ba9a3c6763eaaaae4054103>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useTranscodeVideoMutation$variables = {
  url: string;
};
export type useTranscodeVideoMutation$data = {
  readonly transcodeVideo: {
    readonly url: string;
  } | null | undefined;
};
export type useTranscodeVideoMutation = {
  response: useTranscodeVideoMutation$data;
  variables: useTranscodeVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "TranscodeVideoPayload",
    "kind": "LinkedField",
    "name": "transcodeVideo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTranscodeVideoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTranscodeVideoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "414be7aa691a9d9d23e3d2267a073bb7",
    "id": null,
    "metadata": {},
    "name": "useTranscodeVideoMutation",
    "operationKind": "mutation",
    "text": "mutation useTranscodeVideoMutation(\n  $url: String!\n) {\n  transcodeVideo(url: $url) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc85df7cf8e2dd75f0a70c21179f92bb";

export default node;
